import clsx from "clsx";
import React from "react";

import Grid from "@material-ui/core/Grid";

import ListsInfoBlock from "./ListsInfoBlock";
import MatchingHorsesBlock from "./MatchingHorsesBlock";
import RecentRaceBlock from "./RecentRaceBlock";
import ScheduledWorkoutsBlock from "./ScheduledWorkoutsBlock";

import useStyles from "./styles";

export interface Props {
  className?: string;
  isWorkoutRequestsTotalCountLoading: boolean;
  workoutRequestsTotalCount: number;
}

const InfoBlocks = (props: Props) => {
  const {
    className,
    isWorkoutRequestsTotalCountLoading,
    workoutRequestsTotalCount
  } = props;

  const classes = useStyles();

  return (
    <>
      <Grid container className={clsx(classes.root, className)} spacing={2}>
        <Grid item xs={6} md={3} data-test-id={"scheduledWorkoutsGrid"}>
          <ScheduledWorkoutsBlock
            isLoading={isWorkoutRequestsTotalCountLoading}
            totalCount={workoutRequestsTotalCount}
          />
        </Grid>
        <Grid item xs={6} md={3} data-test-id={"horsesOnListsGrid"}>
          <ListsInfoBlock />
        </Grid>
        <Grid item xs={6} md={3} data-test-id={"matchingHorsesGrid"}>
          <MatchingHorsesBlock />
        </Grid>
        <Grid item xs={6} md={3} data-test-id={"recentRaceGrid"}>
          <RecentRaceBlock />
        </Grid>
      </Grid>
    </>
  );
};

export default React.memo(InfoBlocks);
